export default "__VITE_ASSET__bf084447__"